module.exports = __webpack_public_path__ + "media/images/recruitment/landing/client04-70d341b06d8011bf29dc192ffeddb427.png";